<div class="position-relative d-inline-block" >
    <mat-progress-spinner [mode]="kind"
        [value]="progressValue"
        [diameter]="diameter">
    </mat-progress-spinner>

    <div class="position-absolute top-50 start-50 translate-middle">
        <ng-content></ng-content>
    </div>
</div>
